'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var classNames = require('classnames');
var ListItemText$2 = require('../../../node_modules/@material-ui/core/esm/ListItemText/ListItemText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var styles = {
  listItemTextInset: {
    '&:first-child': {
      paddingLeft: 40
    }
  },
  root: {},
  multiline: {},
  dense: {},
  inset: {},
  primary: {},
  secondary: {}
};

var ListItemText = function ListItemText(_ref) {
  var classes = _ref.classes,
      restOfProps = objectWithoutProperties(_ref, ["classes"]);

  var listItemTextInset = classes.listItemTextInset,
      inset = classes.inset,
      otherClasses = objectWithoutProperties(classes, ["listItemTextInset", "inset"]);

  return React__default["default"].createElement(ListItemText$2["default"], _extends["default"]({}, restOfProps, {
    classes: _objectSpread({
      inset: classNames__default["default"](inset, listItemTextInset)
    }, otherClasses)
  }));
};

var ListItemText$1 = withStyles["default"](styles)(ListItemText);

module.exports = ListItemText$1;
